import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_PERMISSIONS } from '@/modules/Core/constants/adminAccess'

const SecretariatRoutes: RouteRecordRaw = {
  path: '/secretariat',
  name: 'SecretariatModulePages',
  redirect: { name: 'ManageLettersRoute' },
  children: [
    {
      path: '',
      name: 'ManageLettersRoute',
      component: () => import('./views/ManageLettersView.vue'),
      meta: {
        title: 'لیست نامه‌ها',
        requiredPermissions: [...MODULE_PERMISSIONS.secretariatList],
      },
    },
    {
      path: 'create',
      name: 'CreateLetterRoute',
      component: () => import('./views/CreateLetterView.vue'),
      meta: {
        title: 'ایجاد نامه',
        pageHasBack: true,
        requiredPermissions: [...MODULE_PERMISSIONS.secretariatCreate],
      },
    },
    {
      path: ':id/referrals',
      name: 'LetterReferralsRoute',
      component: () => import('./views/LetterReferralsView.vue'),
      meta: {
        title: 'پاسخ‌ها و ارجاعات',
        pageHasBack: true,
        requiredPermissions: [...MODULE_PERMISSIONS.secretariatRead],
      },
    },
    {
      path: ':id/recipients',
      name: 'LetterRecipientsStatusRoute',
      component: () => import('./views/LetterRecipientsStatusView.vue'),
      meta: {
        title: 'وضعیت دریافت کننده‌ها',
        pageHasBack: true,
        requiredPermissions: [...MODULE_PERMISSIONS.secretariatRead],
      },
    },
    {
      path: ':id/edit',
      name: 'EditLetterRoute',
      component: () => import('./views/EditLetterView.vue'),
      meta: {
        title: 'ویرایش نامه',
        pageHasBack: true,
        requiredPermissions: [...MODULE_PERMISSIONS.secretariatCreate],
      },
    },
    {
      path: ':id/reply',
      name: 'LetterReplyRoute',
      component: () => import('./views/ReplyLetterView.vue'),
      meta: {
        title: 'پاسخ',
        pageHasBack: true,
        requiredPermissions: [...MODULE_PERMISSIONS.secretariatReply],
      },
    },
    {
      path: ':id',
      name: 'LetterDetailRoute',
      component: () => import('./views/LetterDetailView.vue'),
      meta: {
        title: 'نمایش نامه',
        pageHasBack: true,
        requiredPermissions: [...MODULE_PERMISSIONS.secretariatRead],
      },
    },
  ],
  meta: {
    layout: 'Default',
    requiredPermissions: [...MODULE_PERMISSIONS.secretariatModule],
    permissionMode: 'any',
  },
}

export default (router: Router) => {
  router.addRoute(SecretariatRoutes)
}
